import { ReactElement, Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from '@mui/material';
import {
  isUserProfileReadComplete,
  IUser,
  TabPanel,
  TabsNav,
  SelectNav,
} from '../common';
import { find } from 'lodash/fp';
import { Registrations } from '../registration';
import { SaveRequest } from '../request';
import { RequestStatusEndUser } from '../request-status-end-user';
import { DownloadCertificates, ListCertificates } from '../download-certificates';

export const UserTabs = ({
  user,
  currentTab,
  setCurrentTab,
}: {
  user: IUser;
  currentTab: number;
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const matchesTabsBreakpoint = useMediaQuery('(min-width:40em)', {
    noSsr: true,
  });

  return (
    <>
      {matchesTabsBreakpoint && isUserProfileReadComplete(user) && (
        <TabsNav
          currentTab={currentTab}
          labels={labels}
          onChange={setCurrentTab}
          ariaLabel="user tabs"
        />
      )}
      {!matchesTabsBreakpoint && isUserProfileReadComplete(user) && (
        <SelectNav
          currentTab={currentTab}
          labels={labels}
          onChange={setCurrentTab}
          ariaLabel="user tabs"
        />
      )}
      {isUserProfileReadComplete(user) && (
        <TabPanel value={currentTab} label={labels[currentTab].label}>
          {find<{
            value: number;
            panel: () => ReactElement;
          }>({ value: currentTab })(panels())!.panel()}
        </TabPanel>
      )}
    </>
  );
};

const labels = import.meta.env.VITE_DOWNLOAD_CERTIFICATES_FEATURE === 'ENABLED' ? [
  { label: 'CSOS Certificates', value: 0 },
  { label: 'Status of Requests', value: 1 },
  { label: 'Create Request', value: 2 },
  { label: 'Download Certificates', value: 3 },
] : [
  { label: 'CSOS Certificates', value: 0 },
  { label: 'Status of Requests', value: 1 },
  { label: 'Create Request', value: 2 },
];

const panels = () => [
  {
    value: 0,
    panel: () => <Registrations />,
  },

  {
    value: 1,
    panel: () => <RequestStatusEndUser />,
  },

  {
    value: 2,
    panel: () => <SaveRequest />,
  },
  (import.meta.env.VITE_DOWNLOAD_CERTIFICATES_FEATURE === 'ENABLED' && {
    value: 3,
    panel: () => <ListCertificates />,
  }),
];
